import { Dimensions, Sources } from 'components/insights/constants';
import PatientDrillInTable from 'components/insights/layout/details/PatientDrillInTable';
import { useTranslation } from 'context/translations';
import { simpleDate } from 'lib/date';

const TotalDischargesPatientTable = ({
  onSelectedDimensionsChange,
}: {
  onSelectedDimensionsChange: (selectedDimensions: Dimensions[]) => void;
}) => {
  const { translate } = useTranslation();

  return (
    <PatientDrillInTable
      title={`${translate('Discharged')} Patients`}
      source={Sources.LOCATION_EPISODE_DISCHARGES}
      dataCy='dischargedPatientsDrillInTable'
      exportFilename='discharged-patients-export'
      onSelectedDimensionsChange={onSelectedDimensionsChange}
      thirdColumn={{
        dimension: Dimensions.DATE,
        header: `${translate('Discharge')} Date`,
        renderCell: (value: Date) => simpleDate(value),
        parseValue: (rawValue: any) => new Date(rawValue),
      }}
    />
  );
};

export default TotalDischargesPatientTable;
